module.exports = __webpack_public_path__ + "img/go-to-account.f9e753b5.svg";